export default __webpack_public_path__ + "static/media/coin.2fc6e355.svg";